import { Role } from '@/types/auth'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface State {
    accessToken: string | null
    xUserShiftId: string | null
    role: Role | null
    startOfShiftTime: string | null
    endOfShiftTime: string | null
    previousDutyCode: string | null
}

interface Actions {
    setAccessToken: (accessToken: State['accessToken']) => void
    setXUserShiftId: (xUserShiftId: State['xUserShiftId']) => void
    setRole: (xUserShiftId: State['role']) => void
    setStartOfShiftTime: (startOfShiftTime: State['startOfShiftTime']) => void
    setEndOfShiftTime: (endOfShiftTime: State['endOfShiftTime']) => void
    setPreviousDutyCode: (previousDutyCode: State['previousDutyCode']) => void
    clear: () => void
}

export const useAuthStore = create<State & Actions>()(
    persist(
        (set) => ({
            accessToken: null,
            xUserShiftId: null,
            role: null,
            startOfShiftTime: null,
            endOfShiftTime: null,
            previousDutyCode: null,
            setAccessToken: (accessToken) => set({ accessToken }),
            setXUserShiftId: (xUserShiftId) => set({ xUserShiftId }),
            setRole: (role) => set({ role }),
            setStartOfShiftTime: (startOfShiftTime) => set({ startOfShiftTime }),
            setEndOfShiftTime: (endOfShiftTime) => set({ endOfShiftTime }),
            setPreviousDutyCode: (previousDutyCode) => set({ previousDutyCode }),
            clear: () =>
                set({
                    accessToken: null,
                    xUserShiftId: null,
                    role: null,
                    startOfShiftTime: null,
                    endOfShiftTime: null,
                    previousDutyCode: null,
                }),
        }),
        {
            name: 'auth-storage',
        }
    )
)
